import React, { useState } from "react";
import { Modal, Input } from "antd";

import useCreate from "hooks/useCreate";
import TaskColorPicker from "components/TaskColorPicker";

const AddTask = ({
  date,
  handleClose,
  refetch,
}) => {
  const [content, setContent] = useState("");
  const [status_color, setStatusColor] = useState("red");

  const { is_saving, create } = useCreate({
    path: "/tasks",
    onSuccess: refetch,
  });

  const handleOk = async () => {
    try {
      await create({
        status_color,
        content,
        date,
      });
      handleClose();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Modal
      maskClosable={false}
      width={700}
      title="Dodaj priorytet"
      open={true}
      onOk={handleOk}
      onCancel={handleClose}
      cancelText="Anuluj"
      okText="Dodaj"
      okButtonProps={{
        disabled: !content || is_saving,
        loading: is_saving,
      }}
    >
      <Input.TextArea
        value={content}
        style={{ marginBottom: 20 }}
        onChange={({ target: { value } }) =>
          setContent(value)
        }
        rows={7}
        maxLength={400}
        showCount={true}
      />
      <TaskColorPicker
        active_color={status_color}
        setColor={setStatusColor}
      />
    </Modal>
  );
};

export default AddTask;
